module.exports = __webpack_public_path__ + "img/logo-mikshito-desktop.a6ccfd2a.svg";